import { useState, Fragment } from 'react';
import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { InfoBanner } from 'ui/banner';
import { PageHeader } from 'ui/pageHeader';
import { FormField } from 'ui/formField';
import { Divider } from 'ui/divider';
import { Tag } from 'ui/tags';
import { spacing } from 'ui/theme';
import { endpoints } from '../endpoints';
import EndpointForm from './AdminEndpointForm';

const AdminRoute = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: ${spacing.half};
`;

const InfoBannerWrapper = styled.div`
  margin: ${spacing.double} 0;
  width: fit-content;
`;

const AdminEndpointList = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: ${spacing.double};
  margin: ${spacing.base} 0;
`;

const FormFieldContainer = styled.div`
  width: 50%;
  margin-left: auto;
`;

const AdminEndpoints = () => {
  const [displayedForms, setDisplayedForms] = useState(endpoints);
  const [filter, setFilter] = useState('');

  const filterList = (value: string) => {
    const forms = endpoints.filter(({ route }) =>
      route.toLowerCase().includes(value.toLowerCase()),
    );
    setDisplayedForms(forms);
    setFilter(value);
  };

  return (
    <>
      <PageHeader data-test="admin-endpoints-header">Admin endpoints</PageHeader>
      <InfoBannerWrapper>
        <InfoBanner>
          In order to access the endpoints, certain cookies need to be set in your browser. Navigate
          to the project you want to affect to set the cookies.
        </InfoBanner>
      </InfoBannerWrapper>
      <FormFieldContainer>
        <FormField inputId="endpointFilter" labelText="Filter the endpoint list">
          <InputText
            value={filter}
            id="endpointFilter"
            data-test="adminEndpointList-filterInput"
            placeholder="/admin/deleteUsersFromList"
            onChange={filterList}
          />
        </FormField>
      </FormFieldContainer>
      <Divider />
      {displayedForms.map(({ key, method, opts, route, actions }) => (
        <Fragment key={key}>
          <AdminEndpointList data-test="adminEndpointList">
            <AdminRoute data-test="adminEndpointList-route">
              {method && <Tag>{method}</Tag>}
              <span>{route}</span>
            </AdminRoute>
            <EndpointForm route={route} opts={opts} method={method} actions={actions} />
          </AdminEndpointList>
          <Divider />
        </Fragment>
      ))}
    </>
  );
};

export default AdminEndpoints;
